import { useContext } from 'react'

import {
  INTL_DMY_CASUAL_FORMAT,
  INTL_DAY_MONTH_NAME,
} from 'constants/dateFormats'
import GeoContext from 'contexts/geoContext'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'
import { formatDynamicAmountWithDollarType } from 'lib/format/formatCurrencyIntl'
import BookingItemCard from 'tripPlanner/components/ItemCard/BookingItemCard'
import type { OfferTypeForTripItemTypes } from 'tripPlanner/hooks/api/common'

type Props = {
  bedbankOrderItem: App.OrderBedbankItem
  showBorder?: boolean
  order?: App.Order
  onSelect?: (
    order: App.Order,
    offers: Array<OfferTypeForTripItemTypes>,
    checked: boolean,
  ) => void
}

function BedBankBookingCard(props: Props) {
  const { currentCurrency, currentRegionCode } = useContext(GeoContext)
  const { bedbankOrderItem, showBorder, order, onSelect } = props
  const { offer } = bedbankOrderItem
  const intlDateFormatter = useIntlDateFormatter()

  return (
    <BookingItemCard
      onSelect={(checked) => {
        if (onSelect && order) {
          onSelect(order, [offer], checked)
        }
      }}
      heading={offer.name}
      image={offer.image}
      subHeading={`${intlDateFormatter(
        bedbankOrderItem.checkIn,
        INTL_DAY_MONTH_NAME,
      )} – ${intlDateFormatter(
        bedbankOrderItem.checkOut,
        INTL_DMY_CASUAL_FORMAT,
      )}`}
      price={formatDynamicAmountWithDollarType(
        bedbankOrderItem.total,
        currentCurrency,
        currentRegionCode,
      )}
      showBorder={showBorder}
    />
  )
}

export default BedBankBookingCard
